@if (freeBetToken$ | async; as freeBet) {
    <bs-freebet-stake [freeBetToken]="freeBet" [isLinear]="true" />
} @else {
    @if (stake$ | async; as stake) {
        <ms-stake
            [stake]="getStakeAsStr(stake.stake)"
            [errors]="hasStakeError$"
            [keypadId]="keypadId"
            [numpadSource]="numpadSource"
            [adornmentStart]="(adornmentText$ | async) ?? undefined"
            [emptyCharacter]="messages.linear.StakePlaceholder"
            [focusPlaceholder]="focusPlaceholder"
            [disabled]="isDisabled"
            [useStakeFieldCursor]="useStakeFieldCursor"
            (stakeChanged)="setStake($event)" />
    }
}
